import React from 'react';
import {List, ListItem, makeStyles, Typography} from "@material-ui/core";
import Technologies from './Technologies';

const Skills = ({title,dark,id}) => {
    const classes = useStyles();
    return (
        <div className={`${classes.section} 
        ${dark && classes.sectiondark}`}>
            <div className={classes.sectioncontent} id={id}>
               <div className={classes.contenttitle} >
               <Typography className={classes.title}  variant="h3" >{title}</Typography>
               </div>
               
                <div className={classes.contentTech}>
                 <Technologies/>
                
                </div>
                
             </div>
        </div>
    )
}

const useStyles = makeStyles((theme) => ({ 
    section: {
        
        color:"#0c82ad",
        fontWeight:"bold",
       minHeight:"70vh",
       background:"#d4d5d6",
       
       
    },
    
    sectioncontent:{
        
        marginTop:theme.spacing(9),
        "& h3":{
            marginBottom:theme.spacing(4),
            
        }
    },
    contentTech:{
        background:'#d4d5d6',
       
        
    },
    contenttitle:{
        textAlign:"center",
       margin:theme.spacing(1),

    },
    title:{
       
       
       
    }
  }))

export default Skills;
